import Image from "next/image";
// import Button from "@/Components/Button";
import Breadcrumb from "@/Components/Breadcrumb/Breadcrumb";

interface BannerProps {
  data?: any;
  parent?: any;
  breadcrumbs?: any;
  isMobile?: any;
}

const Banner: React.FC<BannerProps> = ({ data, breadcrumbs, isMobile }: BannerProps) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

  return (
    <section className="relative bg-background-dark text-white pt-[140px] xl:pt-[180px] py-[56px] xl:py-[100px]  md:pt-[154px] md:py-[80px] overflow-hidden">
      {/* Background Image */}

      {!isMobile &&
        <Image
          src="/images/about/bg.png"
          width={1000}
          height={576}
          alt="banner-vector"
          className="absolute w-[100%] h-[576px] bottom-0 left-0 top-0 right-0 z-1 bg-cover bg-no-repeat bg-center sm:block hidden"
          quality={80}
          loading="eager"
          priority
        />
      }
      
      {isMobile &&
        <Image
          src="/images/about/bg-banner-m.png"
          width={1000}
          height={576}
          alt="banner-vector"
          className="absolute w-[100%] h-[328px] bottom-0 left-0 top-0 right-0 z-1 bg-cover bg-no-repeat bg-center sm:hidden block"
          quality={80}
          loading="eager"
          priority
        />
      }

      {/* Content */}
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="flex flex-col items-center justify-center mx-auto">
          {breadcrumbs?.item?.length > 0 && (
            <Breadcrumb
              items={breadcrumbs?.item ?? []}
              className2="text-subtitle-3 text-center text-gray-300"
              className=" text-gray-300 xl:mb-[48px] md:mb-[16px] mb-[16px] xl:mt-[32px]  whitespace-nowrap overflow-hidden w-[95%] text-ellipsis flex-row text-subtitle-3 md:text-subtitle-3 md:mt-[0] flex items-center justify-center text-center"
            />
          )}
          <div className="flex flex-col items-center justify-center">
            {data?.animation_media?.data?.attributes?.url && (
              <Image
                alt="banner"
                src={baseUrl + data?.animation_media?.data?.attributes?.url}
                width={584}
                height={197}
                className="md:w-[420px] xl:w-[584px] w-[256px] "
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
